export default "__VITE_ASSET__DCz53MQu__"